/**
 * Card-friendly cabins label: keeps only the part before any parenthetical
 * breakdown. "5 (1 Master, 2 Double, ...)" -> "5". Numbers pass through.
 * Junk/empty values ("", "()", "( )", "(Open)") return null so callers can
 * hide the spec or show a dash. Full detail stays available on the yacht
 * detail page / title attribute.
 */
export function formatCabins(value) {
  if (value == null || value === "") return null;
  const short = String(value).split("(")[0].trim();
  // Nothing meaningful left once parentheses/whitespace are stripped
  if (!short.replace(/[()\s—-]/g, "")) return null;
  return short;
}
